module.exports = __webpack_public_path__ + "static/img/privacy_count_8.8ba36079.svg";